{
  "ServiceRequest": "Service Request",
  "SparePartOrder": "Spare Part Order",
  "PreventiveMaintenance": "Preventive Maintenance",
  "FormSubmission": "Form Submission"
}
